import React from 'react';
import { useTranslation } from 'react-i18next';
import { TableRow, TableCell } from '@material-ui/core';

import { RaceCompetitor } from 'src/interfaces/RacingState';
import SimpleTabs from 'src/components/SimpleTabs/SimpleTabs';

interface ExpandedRowProps {
  colSpan: number,
  competitor: RaceCompetitor,
  trainerName: string,
  racingType: string
}

export default function ExpandedRow({ colSpan, competitor, trainerName, racingType }: ExpandedRowProps) {
  const { t } = useTranslation('common');

  const checkHorseTab = () => {
    if (competitor.horse.name || competitor.horse.gender || (competitor.horse.bornYear !== 0 && competitor.horse.bornYear)
      || competitor.horse.color || competitor.horse.sire || competitor.horse.dam
      || trainerName !== '-' || competitor.horse.owner || competitor.horse.ownerCountry
      || competitor.horse.raisedCountry || competitor.horse.bornCountry) {
      return true;
    }

    return false;
  };

  const checkJockeyTab = () => {
    if (competitor.jockey.name || competitor.jockey.country || competitor.jockey.amateur !== 0) {
      if (racingType === 'dogs') {
        return false;
      }
      return true;
    }

    return false;
  };

  const checkTrainerTab = () => {
    if ((trainerName && trainerName !== '-') || competitor.trainer.country || competitor.trainer.amateur !== 0) {
      return true;
    }

    return false;
  };

  const addLabels = () => {
    const labels = [];

    if (checkHorseTab()) {
      if (racingType === 'horses' || racingType === 'carriages') {
        labels.push({ label: t('racingDetail.horse') });
      } else {
        labels.push({ label: t('racingDetail.dog') });
      }
    }

    if (checkJockeyTab()) {
      if (racingType === 'carriages') {
        labels.push({ label: t('racingDetail.driver') });
      } else {
        labels.push({ label: t('racingDetail.jockey') });
      }
    }

    if (checkTrainerTab()) {
      labels.push({ label: t('racingDetail.trainer') });
    }

    return labels;
  };

  const checkHorseTabFirstHalf = () => {
    if (competitor.horse.name || competitor.horse.gender || (competitor.horse.bornYear !== 0 && competitor.horse.bornYear)
    || competitor.horse.color || competitor.horse.sire || competitor.horse.dam) {
      return true;
    }

    return false;
  };

  const horseTab = () => {
    return (
      <div className="competitors-table__info-table" key="horseTab">
        {
          checkHorseTabFirstHalf() &&
            <>
              <div>
                { competitor.horse.name &&  <div className="competitors-table__info-label">{ t('racingDetail.name') }:</div> }
                { competitor.horse.gender && <div className="competitors-table__info-label">{ t('racingDetail.gender') }:</div> }
                {
                  (competitor.horse.bornYear && competitor.horse.bornYear !== 0) &&
                    <div className="competitors-table__info-label">{ t('racingDetail.born') }:</div>
                }
                { competitor.horse.color && <div className="competitors-table__info-label">{ t('racingDetail.colour') }:</div> }
                { competitor.horse.sire && <div className="competitors-table__info-label">{ t('racingDetail.sire') }:</div> }
                { competitor.horse.dam && <div className="competitors-table__info-label">{ t('racingDetail.dam') }:</div> }
              </div>
              <div>
                { competitor.horse.name && <div>{ competitor.horse.name }</div> }
                { competitor.horse.gender && <div>{ competitor.horse.gender }</div> }
                {
                  (competitor.horse.bornYear && competitor.horse.bornYear !== 0) &&
                    <div>{ competitor.horse.bornYear }</div>
                }
                { competitor.horse.color && <div>{ competitor.horse.color }</div> }
                { competitor.horse.sire && <div>{ competitor.horse.sire }</div> }
                { competitor.horse.dam && <div>{ competitor.horse.dam }</div> }
              </div>
            </>
        }
        <div>
          { trainerName && trainerName !== '-' && <div className="competitors-table__info-label">{ t('racingDetail.trainer') }:</div> }
          { competitor.horse.owner && <div className="competitors-table__info-label">{ t('racingDetail.owner') }:</div> }
          { competitor.horse.ownerCountry && <div className="competitors-table__info-label">{ t('racingDetail.country') }:</div> }
          { competitor.horse.raisedCountry && <div className="competitors -table__info-label">{ t('racingDetail.raisedCountry') }:</div> }
          { competitor.horse.bornCountry && <div className="competitors-table__info-label">{ t('racingDetail.bornCountry') }:</div> }
        </div>
        <div>
          { trainerName && trainerName !== '-' && <div>{ trainerName }</div> }
          { competitor.horse.owner && <div>{ competitor.horse.owner }</div> }
          { competitor.horse.ownerCountry && <div>{ competitor.horse.ownerCountry }</div> }
          { competitor.horse.raisedCountry && <div>{ competitor.horse.raisedCountry }</div> }
          { competitor.horse.bornCountry && <div>{ competitor.horse.bornCountry }</div> }
        </div>
      </div>
    );
  };

  const jockeyTab = () => {
    return (
      <div className="competitors-table__info-table" key="jockeyTab">
        <div>
          { competitor.jockey.name && <div className="competitors-table__info-label">{ t('racingDetail.name') }:</div> }
          { competitor.jockey.country && <div className="competitors-table__info-label">{ t('racingDetail.country') }:</div> }
          { competitor.jockey.amateur !== 0 && <div className="competitors-table__info-label">{ t('racingDetail.amateur') }:</div> }
        </div>
        <div>
          { competitor.jockey.name && <div>{ competitor.jockey.name }</div> }
          { competitor.jockey.country && <div>{ competitor.jockey.country }</div> }
          { competitor.jockey.amateur !== 0 && <div>{ !!competitor.jockey.amateur ? 'Yes' : 'No' }</div> }
        </div>
      </div>
    );
  };

  const trainerTab = () => {
    return (
      <div className="competitors-table__info-table" key="trainerTab">
        <div>
          { trainerName && trainerName !== '-' &&<div className="competitors-table__info-label">{ t('racingDetail.trainer') }:</div> }
          { competitor.trainer.country && <div className="competitors-table__info-label">{ t('racingDetail.country') }:</div> }
          { competitor.trainer.amateur !== 0 && <div className="competitors-table__info-label">{ t('racingDetail.amateur') }:</div> }
        </div>
        <div>
          { trainerName && trainerName !== '-' && <div>{ trainerName }</div> }
          { competitor.trainer.country && <div>{ competitor.trainer.country }</div> }
          { competitor.trainer.amateur !== 0 && <div>{ !!competitor.trainer.amateur ? 'Yes' : 'No' }</div> }
        </div>
      </div>
    );
  };

  const addTabs = () => {
    const tabs = [];

    if (checkHorseTab()) {
      tabs.push(horseTab());
    }

    if (checkJockeyTab()) {
      tabs.push(jockeyTab());
    }

    if (checkTrainerTab()) {
      tabs.push(trainerTab());
    }

    return tabs;
  };

  if (checkJockeyTab || checkHorseTab || checkTrainerTab) {
    return (
      <TableRow className="competitors-table__info-table-container">
        <TableCell colSpan={ colSpan }>
          <SimpleTabs
            labels={ addLabels() }
            containerClass="competitors-table"
            showIndicator={ false }
            variant="fullWidth"
          >
            { addTabs() }
          </SimpleTabs>
        </TableCell>
      </TableRow>
    );
  } else {
    return <div></div>;
  }
}
